/**
 * External dependencies
 */
import React, { useState } from "react";
import { connect } from "react-redux";
import { useDropzone } from "react-dropzone";
import { first } from "lodash";
import { Box, Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import {
  requestInProgressOperation,
  createOperation,
} from "state/import-operation/actions";
import Button from "components/button";

/**
 * Style dependencies
 */
import "./styles.scss";

const UploadForm = (props) => {
  const [uploading, setUploading] = useState(false);

  const { getRootProps, acceptedFiles, getInputProps } = useDropzone({
    multiple: false,
    accept: ".csv",
  });

  const isDisabled = () => {
    return acceptedFiles.length === 0 || uploading;
  };

  const uploadFile = async () => {
    setUploading(true);
    try {
      await props.createOperation(first(acceptedFiles));
    } catch (error) {
      console.log(error);
    }
    setUploading(false);
  };

  const hasFile = () => acceptedFiles.length >= 1;
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>{file.path}</li>
  ));

  return (
    <div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="upload-form__drop">
          {hasFile() ? (
            <ul>{files}</ul>
          ) : (
            <Box>
              <Text textAlign="center">Upload file</Text>
              <Text>(Only *.csv files will be accepted)</Text>
            </Box>
          )}
        </div>
      </div>
      <Box marginTop="large" justifyContent="flexEnd" display="flex">
        <Button disabled={isDisabled()} onClick={uploadFile} type="submit">
          import data
        </Button>
      </Box>
    </div>
  );
};

export default connect((state) => ({}), {
  requestInProgressOperation,
  createOperation,
})(UploadForm);
